import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import React, { useContext } from 'react';
import { getMailListItemDataProps } from '../utils/mailList/getMailListItemDataProps';
import type { GetRichContentsProps } from './helpers/getRichContents';
import { getRichContents } from './helpers/getRichContents';
import type { MailListItemContainerProps } from '../schema/MailListItemContainer.types';
import { MailListItemWithTouchBehavior } from './MailListItemWithTouchBehavior';
import { MailListViewBehaviorContext } from 'mini-mail-list-behavior-connect/lib/context-providers/MailListViewBehaviorContext';
import { observer } from 'mobx-react-lite';
import SectionDivider from './VirtualizedListView/SectionDivider';
import { isGroupByEmailsFeatureEnabled } from '../utils/isGroupByEmailsFeatureEnabled';

const MailListItemContainer: React.FC<MailListItemContainerProps> = props => {
    const { rowId, prevItemId, appliedRichContentFlags } = props;
    const richContents = getRichContents({
        rowId,
        appliedRichContentFlags,
    } as GetRichContentsProps);
    const mailListViewBehaviorContext = useContext(MailListViewBehaviorContext);
    const onMailListItemClick = mailListViewBehaviorContext?.onMailListItemClick;
    const onMailListItemSwipe = mailListViewBehaviorContext?.onMailListItemSwipe;
    const disableMultiSelect = !!mailListViewBehaviorContext?.disableMultiSelect;
    return (
        <>
            {isGroupByEmailsFeatureEnabled() ? (
                <>
                    <SectionDivider itemId={rowId} prevItemId={prevItemId} />
                    <div>
                        <MailListItemWithTouchBehavior
                            mailListItemDataProps={getMailListItemDataProps(rowId)}
                            tableViewId={getSelectedTableView().id}
                            richContents={richContents}
                            onMailListItemClick={onMailListItemClick}
                            onMailListItemSwipe={onMailListItemSwipe}
                            disableMultiSelect={disableMultiSelect}
                        />
                    </div>
                </>
            ) : (
                <MailListItemWithTouchBehavior
                    mailListItemDataProps={getMailListItemDataProps(rowId)}
                    tableViewId={getSelectedTableView().id}
                    richContents={richContents}
                    onMailListItemClick={onMailListItemClick}
                    onMailListItemSwipe={onMailListItemSwipe}
                    disableMultiSelect={disableMultiSelect}
                />
            )}
        </>
    );
};

export default observer(MailListItemContainer);
